import { render } from "./LoadingAnimation.vue?vue&type=template&id=535baa0e&scoped=true"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js"

import "./LoadingAnimation.vue?vue&type=style&index=0&id=535baa0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-535baa0e"

export default script